import React from "react";

import "./di-styles.css"

const diHeader = () => {
  return (
    <section className="di-header-wrapper" id="di-header">
      <div className="di-inner">
        <h1 className="main-header t-white">Digital Infrastructure</h1>
      </div>
    </section>
  );
};

export default diHeader;
